import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, reactive } from "vue";
import DashboardTable from "./DashboardTable.vue";
import { useDataStore } from "@/store/data-store";
import { Utils } from "@/classes/utils/utils";
import { UserQueryInputSortPropertyEnum, ProjectQueryInputSortPropertyEnum, ProjectQueryInputSortOrderEnum, UserQueryInputSortOrderEnum } from "@/swagger";
import { useRoute, useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersTable',
  setup(__props) {


const dataStore = useDataStore();
const route = useRoute();
const router = useRouter();

const data = reactive({
	columns: ["Firstname", "Lastname", "Email", "Date created", "Projects", "Survey", "Storage", "Is Admin", "License"],
	usersPerPage: 15,
	currentPage: 0,
	pageCount: 5,
	users: [] as any[],
	searchString: "",
	sortColumns: {
		"3": 0,
		"6": 0
	}
})

async function onPageChanged(page: number){
	console.log("Page changed:", page);
	data.currentPage = page;
	refreshUsers();
}

async function onSearchChanged(searchString: string){
	console.log("Search result changed:", searchString);
	data.currentPage = 0;
	data.searchString = searchString;
	refreshUsers();
}

function onSortChanged(columnIndex: number, order: number){
	//Reset all filters
	for(var column in data.sortColumns){
		data.sortColumns[column] = 0;
	}
	data.sortColumns[columnIndex.toString()] = order;
	refreshUsers();
}

function getCurrentSortProperty(): UserQueryInputSortPropertyEnum | undefined{
	if(data.sortColumns["3"] !== 0){
		return UserQueryInputSortPropertyEnum.CreatedDate;
	}else if(data.sortColumns["6"] !== 0){
		return UserQueryInputSortPropertyEnum.UsedStorage;
	}else{
		return undefined;
	}
}

function getSortOrder(property: UserQueryInputSortPropertyEnum): UserQueryInputSortOrderEnum | undefined{
	let order: number | undefined = undefined;

	switch(property){
		case UserQueryInputSortPropertyEnum.CreatedDate:
			order = data.sortColumns["3"];
			break;
		case UserQueryInputSortPropertyEnum.UsedStorage:
			order = data.sortColumns["6"];
			break;
	}
	
	return order < 0 ? UserQueryInputSortOrderEnum.Asc : (order > 0 ? UserQueryInputSortOrderEnum.Desc : undefined);
}

function onRowClicked(userData: any){
	console.log("Clicked user:", userData);
	router.push({name:"projects-and-storage", query: { searchString : userData[2]}})
}

async function refreshUsers(){
	const sortProperty = getCurrentSortProperty();

	var usersResponse = await dataStore.getUsers({
		searchString: data.searchString, 
		offset: data.currentPage * data.usersPerPage,
		limit: data.usersPerPage,
		sortProperty: sortProperty,
		sortOrder: getSortOrder(sortProperty)
	});
	data.users = usersResponse.data.map((u) => 
	[
		u.name, 
		u.lastname, 
		u.email,
		u.createdDate?.toLocaleDateString(),
		u.projectCount, 
		u.surveyCount, 
		Utils.formatBytes(u.usedStorage) + "/" + Utils.formatBytes(u.availableStorage), 
		u.admin ? "✓" : "", u.licenseValid ? "✓" : ""
	]);
	data.pageCount = Math.ceil(usersResponse.totalCount / data.usersPerPage);
}

onMounted(async ()=>{
	if(route.query.sortProperty == UserQueryInputSortPropertyEnum.CreatedDate){
		data.sortColumns["3"] = 1;
	}
	refreshUsers();
	// data.users = [
	// 	["Samo", "Pajk", "samo.pajk@razum.si", 4, 10, "20GB", "15GB", false],
	// 	["Samo", "Pajk", "samo.pajk@razum.si", 4, 10, "20GB", "15GB", true],
	// 	["Samo", "Pajk", "samo.pajk@razum.si", 4, 10, "20GB", "15GB", false],
	// 	["Samo", "Pajk", "samo.pajk@razum.si", 4, 10, "20GB", "15GB", false],
	// 	["Samo", "Pajk", "samo.pajk@razum.si", 4, 10, "20GB", "15GB", false],
	// 	["Samo", "Pajk", "samo.pajk@razum.si", 4, 10, "20GB", "15GB", false]
	// ]
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardTable, {
    class: "users-table",
    columns: data.columns,
    data: data.users,
    "show-search": true,
    "current-page": data.currentPage,
    "page-count": data.pageCount,
    onOnSearch: onSearchChanged,
    onOnPageChanged: onPageChanged,
    "sortable-columns": data.sortColumns,
    onOnSortChanged: onSortChanged,
    onOnRowClick: onRowClicked
  }, null, 8, ["columns", "data", "current-page", "page-count", "sortable-columns"]))
}
}

})